export default __webpack_public_path__ + "static/Денежный поток 7-0e88f2b7d886f6dea60d366d1682f6d2.jpg";